import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Trophy, Medal, Award, Users, TrendingUp } from 'lucide-react';
import { Card } from '../components/ui/card';
import { API } from '../context/AuthContext';
import axios from 'axios';

export default function LeaderboardPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/leaderboard`)
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const rankColors = ['from-amber-400 to-yellow-500', 'from-gray-300 to-gray-400', 'from-orange-500 to-amber-700'];
  const rankIcons = [Trophy, Medal, Award];

  return (
    <div className="px-4 pt-4 space-y-4">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-emerald-600 font-medium">
        <ArrowLeft size={16} /> ମୁଖ୍ୟ ପେଜ କୁ ଫେରନ୍ତୁ
      </Link>

      <div className="rounded-3xl p-5 text-white shadow-lg" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 55%, #eab308 100%)' }}>
        <Trophy size={26} />
        <h1 className="text-xl font-extrabold mt-2">Top Scorers · ଶ୍ରେଷ୍ଠ ଛାତ୍ର</h1>
        <p className="text-xs text-white/90 mt-1">Quiz ର Total Score ଅନୁସାରେ ranking</p>
      </div>

      {loading ? (
        <Card className="rounded-2xl p-8 border-gray-200 text-center text-sm text-gray-500">Loading...</Card>
      ) : items.length === 0 ? (
        <Card className="rounded-2xl p-8 border-gray-200 text-center">
          <Users size={40} className="mx-auto text-gray-300 mb-2" />
          <div className="text-sm text-gray-600 font-semibold">କେହି score submit କରି ନାହାନ୍ତି</div>
          <div className="text-[11px] text-gray-500 mt-1">Quiz ଦେଇ ପ୍ରଥମେ leaderboard ରେ ଆସନ୍ତୁ!</div>
          <Link to="/quiz" className="inline-block mt-4 bg-purple-600 text-white font-bold px-5 py-2 rounded-full text-sm">Quiz ଦିଅନ୍ତୁ</Link>
        </Card>
      ) : (
        <div className="space-y-2">
          {items.map((it) => {
            const isTop = it.rank <= 3;
            const RankIcon = isTop ? rankIcons[it.rank - 1] : null;
            return (
              <Card key={it.rank} className={`rounded-2xl p-3 border ${isTop ? 'border-amber-200 bg-gradient-to-r from-amber-50 to-orange-50' : 'border-gray-200 bg-white'}`}>
                <div className="flex items-center gap-3">
                  {isTop ? (
                    <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${rankColors[it.rank - 1]} text-white flex items-center justify-center shadow-md`}>
                      <RankIcon size={20} />
                    </div>
                  ) : (
                    <div className="w-11 h-11 rounded-xl bg-gray-100 text-gray-600 flex items-center justify-center font-extrabold">
                      #{it.rank}
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-sm text-gray-900 truncate">{it.user_name}</div>
                    <div className="text-[10px] text-gray-500 flex items-center gap-1.5">
                      <span>{it.quizzes_taken} quiz</span> · <span>{it.avg_percentage}% avg</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-extrabold text-lg text-emerald-600">{it.total_score}</div>
                    <div className="text-[9px] text-gray-500 uppercase">Points</div>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}

      <Link to="/quiz" className="block bg-gradient-to-r from-purple-600 to-pink-600 text-white text-center font-bold py-3 rounded-2xl shadow-md">
        <TrendingUp size={16} className="inline mr-1" /> Quiz ଦେଇ ଉପରକୁ ଉଠନ୍ତୁ
      </Link>
    </div>
  );
}
